import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";
import { useConsent, setConsent } from "@/lib/consent";

export default function CookieBanner() {
  const consent = useConsent();
  if (consent) return null;
  const btn = "flex-1 sm:flex-none rounded-full px-6 py-2.5 text-sm font-bold transition-colors";
  return (
    <div className="fixed inset-x-3 bottom-3 sm:inset-x-auto sm:right-5 sm:bottom-5 sm:max-w-md z-50 rounded-2xl bg-slate-900 text-slate-200 p-5 shadow-2xl border border-slate-700" role="dialog" aria-label="Cookie consent" data-testid="cookie-banner">
      <div className="flex items-start gap-3">
        <Cookie className="h-5 w-5 text-green-500 shrink-0 mt-0.5" />
        <p className="text-sm leading-relaxed">
          We use essential storage to run this site. With your permission, we also load an OpenStreetMap map, which may set its own cookies.{" "}
          <Link to="/cookies" className="underline text-green-400" data-testid="cookie-banner-policy-link">Cookie Policy</Link>
        </p>
      </div>
      <div className="flex gap-2 mt-4">
        <button onClick={() => setConsent("rejected")} className={`${btn} bg-slate-700 text-white hover:bg-slate-600`} data-testid="cookie-reject-btn">Reject</button>
        <button onClick={() => setConsent("accepted")} className={`${btn} bg-green-600 text-white hover:bg-green-700`} data-testid="cookie-accept-btn">Accept</button>
      </div>
    </div>
  );
}
